export default __webpack_public_path__ + "static/media/home.639c27c8.svg";